import React from 'react';
import {Redirect} from "react-router-dom";
import {RaisedButton} from "material-ui";

class ServerErrorPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldLogout: false
        }
    }

    render() {
        return (
            <div style={{textAlign: 'center', marginTop: '100px'}}>

                {this.state.shouldLogout && <Redirect to={'/logout'}/>}

                <div>
                    <h1>A aparut o eroare. Va rog sa reincarcati!</h1>
                </div>
                <div>
                    <RaisedButton
                        primary
                        type="submit"
                        label="Reincercati"
                        style={{marginTop: '10px'}}
                        onClick={() => window.location.reload()}
                    />

                    <RaisedButton
                        primary
                        type="submit"
                        label="Logout"
                        style={{marginTop: '10px', marginLeft: '10px'}}
                        onClick={() => this.setState({shouldLogout: true})}
                    />
                </div>
            </div>
        )
    }
}

export default ServerErrorPage;